<control-list-item class="cs__control-list-item"
                   [key]="key"
                   [value]="initialVisibilityState"
                   [controlType]="controlType.Toggle"
                   (onValueChanged)="setStepperVisibility($event)">
</control-list-item>
<stepper-control class="cs__stepper" [class.hidden]="!showStepper"
                 [initialValue]="selectedValue ?? stepperConfig.initialValue"
                 [step]="stepperConfig.step"
                 [disabled]="disabled"
                 [formatWith]="formatStepperNumber"
                 [maxValue]="stepperConfig.maxValue"
                 [minValue]="stepperConfig.minValue"
                 (onSelect)="onSelect.emit($event)"></stepper-control>
